import { MOBILE_HURDLE } from './breakpoints'

export default {
  container: ['auto', MOBILE_HURDLE],
}
